import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { Button, Label } from '@atlas/ui';

import DebugInfo from 'src/components/DebugInfo/DebugInfo';
import HeaderLogoItem from 'src/components/Layout/Header/HeaderLogoItem';

const InitializationPage = ({ setTerminalKey }) => {
  const clickHandler = useCallback(() => {
    NotificationManager.display({
      data: {
        setTerminalKey,
        text: 'terminal_initialization_popup_message',
        title: 'terminal_initialization_popup_title',
      },
      type: 'terminalInitialization',
    });
  }, [setTerminalKey]);

  return (
    <div className="terminal-initialization-page">
      <div className="terminal-initialization-content">
        <HeaderLogoItem />
        <Label
          className="terminal-initialization-title"
          message="terminal_initialization_page_title"
        />
        <Label
          className="terminal-initialization-message"
          message="terminal_initialization_page_message"
        />
        <Button
          className="terminal-initialization-button"
          label="terminal_initialization_page_button"
          onClick={clickHandler}
          size="huge"
        />
      </div>
      <DebugInfo />
    </div>
  );
};

InitializationPage.propTypes = {
  setTerminalKey: PropTypes.func,
};

export default InitializationPage;
